class MenswearCapture extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.showForm = this.showForm.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    if (this.els.open) {
      this.listeners.add(this.els.open.element, 'click', this.showForm)
    }
  }

  showForm () {
    try {
      this.els.ctaContainer.element.setAttribute('aria-hidden', true)
      this.els.formContainer.element.removeAttribute('aria-hidden')
      this.els.formContainer.element.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      })
    } catch (err) {
      // fail
      console.error(err)
    }
  }
}

if (!customElements.get('menswear-capture')) {
  customElements.define('menswear-capture', MenswearCapture)
}
